// Team color on the premium models (2026-10-25). Every army's sheets paint the team parts (banner, horse cloth, cart
// trim) one deep blue, and nothing else on a unit is strongly blue (the Samurai "black" lacquer is a dark navy, far
// below the cut). The shader finds those texels by how much blue leads red and green, and repaints them in the team
// color at the same brightness, so one model file serves every team. Meshy returns the banner anywhere from deep blue
// to a grey lavender (round 3 swordsman), so the blue team is tinted too, never left as the raw texture.
import * as THREE from 'three';

/** Deep sheet blue, linear: about how bright the banner's blue channel is, so the team color keeps its shading. */
const SHEET_BLUE = 0.3;

/** The repaint, to go right after three's map_fragment: `team` is a vec3 expression (a uniform here, a per-instance
 *  varying in a match, baked.ts). */
export const teamTintGLSL = (team: string) => `
        {
          vec3 c = diffuseColor.rgb;
          float lead = c.b - max(c.r, c.g);              // linear; sheet blue leads by ~0.3, navy lacquer by ~0.01
          float k = smoothstep(0.05, 0.12, lead);
          diffuseColor.rgb = mix(c, ${team} * clamp(c.b / ${SHEET_BLUE.toFixed(2)}, 0.0, 1.6), k);
        }`;

export function tintTeam(root: THREE.Object3D, color: THREE.ColorRepresentation) {
  const team = new THREE.Color(color);
  root.traverse((o) => {
    const m = o as THREE.Mesh;
    if (!m.isMesh) return;
    const mat = (m.material as THREE.MeshStandardMaterial).clone();
    mat.onBeforeCompile = (sh) => {
      sh.uniforms.uTeam = { value: team };
      sh.fragmentShader = 'uniform vec3 uTeam;\n' + sh.fragmentShader.replace('#include <map_fragment>', '#include <map_fragment>' + teamTintGLSL('uTeam'));
    };
    mat.customProgramCacheKey = () => 'team-tint';
    m.material = mat;
  });
}
